import { get, post, put } from '../../api-config';
import { gdpService } from './_service';

export const getEvents = async (data: any) =>
  await get(gdpService, '/events', null, { init: data.init, size: data.size });
export const getEvent = async (data: any) => await get(gdpService, `/events/${data.id}`, null, null);

// Búsqueda de eventos con filtros + facetas (POST /events/search).
export const searchEvents = async (data: any) => await post(gdpService, '/events/search', data, null);

export const putActionResolve = async (data: any) =>
  await put(gdpService, `/dashboard/actions/${data.id}`, null, data.params);

// Reintento manual de la sincronización FHIR de la alerta (CommunicationRequest); solo admins.
export const retryEventIntegration = async (eventId: any) =>
  await post(gdpService, `/events/admin/${eventId}/integration/retry`);

// Event notes
export const getAlarmNotes = (data: any) => get(gdpService, `/events/${data.alarmId}/notes`, data, null);
export const postAlarmNote = (data: any) => post(gdpService, `/events/${data.referenceId}/notes`, data, null);

// Event recordings
export const getAlarmRecordingUrl = (data: any) => get(gdpService, `/events/${data.alarmId}/recording`, data, null);
